"use strict";var p=Object.defineProperty;var c=Object.getOwnPropertyDescriptor;var o=(i,t,l,s)=>{for(var e=s>1?void 0:s?c(t,l):t,n=i.length-1,r;n>=0;n--)(r=i[n])&&(e=(s?r(t,l,e):r(e))||e);return s&&e&&p(t,l,e),e};import{baseStyles as a,CiscoUElement as d,html as m}from"@cisco-u/base";import{property as u,state as h}from"@cisco-u/base/src/decorators.js";import v from"./collapsible.css.js";import"@cisco-u/icons/icons/cu-icon-chevron-down.js";export class Collapsible extends d{constructor(){super(...arguments);this._isOpen=!1}static get styles(){return[a,v]}render(){return m`<div class="collapsible">
      <button
        @click=${()=>this._handleCollapseClick()}
        type="button"
        class="collapsible-btn"
      >
        ${this.btnText}
        <cu-icon-chevron-down
          class="${this._isOpen?" is-open":""}"
          size="m"
        ></cu-icon-chevron-down>
      </button>
      <div class="collapsible-content${this._isOpen?" is-open":""}">
        <slot name="content"></slot>
      </div>
    </div>`}_handleCollapseClick(){this._isOpen=!this._isOpen}}o([u({type:String,reflect:!0})],Collapsible.prototype,"btnText",2),o([h()],Collapsible.prototype,"_isOpen",2);
//# sourceMappingURL=Collapsible.js.map
